// extracted by mini-css-extract-plugin
export var container = "autocomplete-module--container--29685";
export var suggestion = "autocomplete-module--suggestion--8f1d9";
export var suggestionsContainer = "autocomplete-module--suggestionsContainer--19499";